/**
 * @file This file contains the helper types and classes for the submit button.
 */
/**
 * Return an instance of this class as an error to show a warning on your submit button.
 */
export class SubmitButtonWarning {
    /**
     * @param warning The warning to display.
     * @param data Any auxiliary data.
     */
    constructor(warning, data) {
        this.warning = warning;
        this.data = data;
        /** A name to uniquely distinct the class. */
        this.name = 'SubmitButtonWarning';
    }
}
/** Return this as an error to cancel the submit button. */
export const SubmitButtonCancelled = Object.create(Error);
/** Return this as an error to retry the submit function. */
export const SubmitButtonRetry = Symbol('SubmitButtonRetry');
